import { rootApi } from "../../api/rootApi";

export const zonesLocApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllZoneLoc: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/zonesLocations/getAllZone`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body
        };
      },
    }),
    fetchAllEmployeeByCity: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/employee/city/employee-list`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body
        };
      },
    }),
    bulkUploadZoneLoc: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/zonesLocations/bulkMapping`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body
        };
      },
    }),
    updateCity: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/employee/city/update-city`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body
        };
      },
    }),
  })
});

export const {
  useGetAllZoneLocMutation,
  useFetchAllEmployeeByCityMutation,
  useBulkUploadZoneLocMutation,
  useUpdateCityMutation
} = zonesLocApi;